module.exports = __webpack_public_path__ + "img/hairparty.3296ecc1.svg";